import { combineReducers } from 'redux';

import { UPDATE_COLLECTION } from '../actions/collection';

const name = (state = '', { type, payload }) => {
    let newState = state;

    if (type === UPDATE_COLLECTION && payload.name) {
        newState = payload.name;
    }

    return newState;
};

const summary = (state = '', { type, payload }) => {
    let newState = state;

    // Server returns null for empty summary, need to set that
    if (
        type === UPDATE_COLLECTION &&
        (payload.summary || payload.summary === null)
    ) {
        newState = payload.summary;
    }

    return newState;
};

const image = (state = {}, { type, payload }) => {
    let newState = state;

    if (type === UPDATE_COLLECTION && 'image' in payload) {
        newState = payload.image || {};
    }

    return newState;
};

const imageLarge = (state = {}, { type, payload }) => {
    let newState = state;

    if (type === UPDATE_COLLECTION && 'imageLarge' in payload) {
        newState = payload.imageLarge || {};
    }

    if (type === UPDATE_COLLECTION && payload.imageId === null) {
        newState = {};
    }

    return newState;
};

const imageId = (state = null, { type, payload }) => {
    let newState = state;

    if (type === UPDATE_COLLECTION && 'imageId' in payload) {
        newState = payload.imageId;
    }

    return newState;
};

const shareUrl = (state = '', { type, payload }) => {
    let newState = state;

    if (type === UPDATE_COLLECTION && payload.shareUrl) {
        newState = payload.shareUrl;
    }

    return newState;
};

const secret = (state = '', { type, payload }) => {
    let newState = state;

    if (type === UPDATE_COLLECTION && payload.secret) {
        newState = payload.secret;
    }

    return newState;
};

const isFollowing = (state = false, { type, payload }) => {
    let newState = state;

    if (type === UPDATE_COLLECTION && 'isFollowing' in payload) {
        newState = payload.isFollowing;
    }

    return newState;
};

export default combineReducers({
    name,
    shareUrl,
    summary,
    image,
    imageLarge,
    imageId,
    secret,
    creator: (state = {}) => state,
    canCurate: (state = false) => state,
    canEdit: (state = false) => state,
    eventCount: (state = 0) => state,
    isQuality: (state = false) => state,
    isPublic: (state = false) => state,
    isFollowing,
    canAdmin: (state = false) => state,
    id: (state = '') => state,
    type: (state = '') => state,
    followStatus: (state = {}) => state,
    displayCreatorName: (state = '') => state,
    displayCreatorImageId: (state = '') => state,
    displayCreatorImageUrl: (state = '') => state,
    displayCreatorDescription: (state = '') => state,
    artistAttribution: (state = '') => state,
    getCollectionEventsWithSearch: (state = false) => state,
});
